'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './voting-list.routes';

export class VotingListComponent {
  constructor(Auth, VotingsService, DTOptionsBuilder, dialogs, $uibModal, SettingsService) {
    'ngInject';

    this.VotingsService = VotingsService;
    this.votes = [];
    this.isAdmin = Auth.isAdminSync;

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;

    SettingsService.getByName({name: 'config.app'}, settings => {
      let ssDT = settings.data.serverSideDT || {};
      this.serverSideDT = ssDT && ssDT.voterGroups && ssDT.voterGroups.enabled;

      this.VotingsService.query((data) => {
        this.votes = data;
      }, err => {
        console.log("Could not retrieve votes.")
      });

    });

    jQuery(document).ready(function() {
      jQuery.extend(jQuery.fn.dataTableExt.oSort, {
        "extract-date-pre": function (value) {
          return moment(value).toDate()
        },
        "extract-date-asc": function (a, b) {
          return ((a < b) ? -1 : ((a > b) ? 1 : 0));
        },
        "extract-date-desc": function (a, b) {
          return ((a < b) ? 1 : ((a > b) ? -1 : 0));
        }
      });
    });

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lfrtip')
      .withOption('order', [1, 'desc'])
      .withOption('columnDefs', [{
        type: 'extract-date',
        targets: [1]
      }]);
  }

  delete(vote) {
    var that = this;

    var voteText = "<br/><br/><b>" + vote.name + "</b><br/><p>" + vote.description + "</p>";

    var dlg = this.dialogs.confirm("Delete Vote?", "Do you really want to delete the vote?" + voteText);
    dlg.result.then(() => {
      // OK delete it
      that.VotingsService.delete({id: vote._id},
        () => {
          that.votes = that.votes.filter(function( obj ) {
            return obj._id !== vote._id;
          });
        },
        err => {
          alert("Could not delete vote");
        });
    }, () => {
      // Cancel
    });
  }

}

export default angular.module('conduu.votingList', [uiRouter])
  .config(routes)
  .component('votingList', {
    template: require('./voting-list.html'),
    controller: VotingListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/voting/voting-list/voting-list.component.js